module.exports = __webpack_public_path__ + "img/ABC-COVER_w.9bd77e12.png";